import { getCurrentCulture, localize } from "client_legacy/ndaw/culture";
import { resolveFormattedTextString } from "./utils";
import { NumberFormatter } from "client/Hooks";

export type FormatUnitOptions = {
	value: number;
	singularForm: LocalizationKey;
	pluralForm: LocalizationKey;
	valuePlaceholder?: string;
	valueFormatter?: NumberFormatter;
};

export function formatUnit(options: FormatUnitOptions): string {
	const {
		value,
		singularForm,
		pluralForm,
		valuePlaceholder = "{{N}}",
		valueFormatter = defaultUnitValueFormatter
	} = options;

	if (value === 1) {
		return localize(singularForm);
	}

	return resolveFormattedTextString({
		template: localize(pluralForm),
		replacements: [
			{
				what: valuePlaceholder,
				filler: valueFormatter(value)
			}
		]
	});
}


function defaultUnitValueFormatter(value: number): string {
	return value.toString(10);
}


export type FormatListKind = "and" | "or";

export function formatList(list: readonly string[], type: FormatListKind = "and"): string {
	const currentCulture: string = getCurrentCulture();

	return new Intl.ListFormat(
		currentCulture,
		{
			style: "long",
			type: type === "and"
				? "conjunction"
				: "disjunction"
		}
	).format(list);
};
